// Overzicht voor platformbeheer: welke owners, admins en platformbeheerders
// nog geen tweede factor hebben. Voorbereiding op het afdwingen van aal2 in de
// policies: dat kan pas als deze lijst leeg is, anders sluit je mensen buiten.
import { t } from '../lib/i18n.js';
import { esc } from '../lib/format.js';

export async function render(sb, el) {
  if (!el) return;
  el.innerHTML = '<div class="spinner"></div>';
  const { data, error } = await sb.rpc('tweestap_overzicht');
  if (error) { el.innerHTML = `<p style="font-size:12px;color:var(--text-3)">${esc(t('tweestap.overzicht.nietbeschikbaar'))}</p>`; return; }
  const rijen = data || [];
  const zonder = rijen.filter(r => !r.tweede_factor);
  const met = rijen.length - zonder.length;
  el.innerHTML = `
    <div style="font-size:13px;margin-bottom:8px">${esc(t('tweestap.overzicht.stand', { met, totaal: rijen.length }))}</div>
    ${zonder.length ? zonder.map(r => `<div class="org-row">
        <div style="flex:1;font-size:13px">${esc(r.email)} <span class="start-sub">${esc(r.organisatie || t('tweestap.overzicht.platform'))}</span></div>
        <span class="role-badge ${esc(r.rol)}">${esc(r.rol)}</span>
      </div>`).join('')
      : `<div class="banner banner-green"><i class="ti ti-circle-check"></i><span>${esc(t('tweestap.overzicht.klaar'))}</span></div>`}`;
}
